import Dialog from "../../atoms/dialog";
import { Button, Grid, Select, MenuItem, InputLabel, TextField, Typography, Checkbox, FormControlLabel } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import DeleteCancel from "../../atoms/buttons/DeleteCancel";


const DeleteAssetAlert = (props) => {
    const { asset, onDelete, onClose } = props;
    const [open, setOpen] = useState(true);
    console.log("DeleteAssetAlert--------->", asset)

    const handleClose = () => {
        setOpen(false);
        onClose()
    }

    return (
        <Dialog
            title={"Delete"}
            open={open}
            handleClose={handleClose}
        >
            <Grid container direction={"row"} spacing={3} >

                <Grid item xs={12}>
                    <Fragment>
                        <Typography>{`Are you want to delete the ${asset?.assetName}?`} </Typography>
                    </Fragment>
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <DeleteCancel onDelete={onDelete} onCancel={onClose} />
                </Grid>
            </Grid>
        </Dialog >
    )

}

export default DeleteAssetAlert;